import { FC } from 'react'
import * as RadixForm from '@radix-ui/react-form'
import { Button, Flex, Text } from '@radix-ui/themes'
import { TetherRoundedIcon } from 'shared/icons'
import { isMintDialogOpenVar } from '../store/dialogs-balance-store'
import styles from '../balance-add.module.scss'

/** Dev USDT mint was EVM-only; on Solana use devnet faucets / program-specific mint flows. */
export const MintForm: FC = () => {
  return (
    <RadixForm.Root
      onSubmit={e => e.preventDefault()}
      className={styles.mintAmountForm}
    >
      <Flex
        className={styles.mintAmount}
        justify={'center'}
        align={'center'}
        gap={'2'}
      >
        <TetherRoundedIcon
          width={'6rem'}
          height={'6rem'}
          className='color-yellow'
        />

        <Text
          size={'3'}
          weight={'medium'}
          className='color-white'
          style={{ maxWidth: '18rem' }}
        >
          In-app mint is not available on Solana. Use your wallet or a devnet
          token faucet for test USDT.
        </Text>
      </Flex>
      <Flex
        className={styles.mintButtonWrap}
        direction={'column'}
      >
        <Button
          variant='soft'
          type='button'
          className={styles.mintDialogButton}
          size='4'
          onClick={() => isMintDialogOpenVar(false)}
        >
          Close
        </Button>
      </Flex>
    </RadixForm.Root>
  )
}
